// src/services/payments.js
import api from './api';

export const initiatePayment = async (contributionId) => {
  const response = await api.post('/payments/initiate', { contribution_id: contributionId });
  return response.data;
};

export const initiateRegistrationPayment = async (data) => {
  const response = await api.post('/payments/register', data);
  return response.data;
};

export const checkPaymentStatus = async (params) => {
  const response = await api.get('/payments/register/status', { params });
  return response.data;
};
export const getRegistrationFee = async (memberId) => {
  const response = await api.get('/payments/register/fee', { params: { member_id: memberId } });
  return response.data;
};